<div>
  @if (title) {
    <h2>{{title}}</h2>
  }
  @if (type === "image" && src) {
    <div class='image-preview'>
      <img [src]='src'/>
    </div>
  }
  <button (click)='openUpload()' mat-flat-button color='accent'>{{uploadLabel | translate}}</button>
</div>